/**
 * @generated SignedSource<<9850f05a7464f8a851fefee9bf632f15>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type OrgAdminStructureQuery$variables = Record<PropertyKey, never>;
export type OrgAdminStructureQuery$data = {
  readonly organisation: {
    readonly id: string;
    readonly name: string;
    readonly workspaces: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
      readonly ownerStores: ReadonlyArray<{
        readonly id: string;
        readonly name: string;
      }>;
      readonly parentId: string | null;
      readonly timezone: string;
    }>;
  };
};
export type OrgAdminStructureQuery = {
  response: OrgAdminStructureQuery$data;
  variables: OrgAdminStructureQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "Organisation",
  "kind": "LinkedField",
  "name": "organisation",
  "plural": false,
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Workspace",
      "kind": "LinkedField",
      "name": "workspaces",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "parentId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "timezone",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Store",
          "kind": "LinkedField",
          "name": "ownerStores",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "OrgAdminStructureQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": (v2/*: any*/),
        "action": "THROW"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "OrgAdminStructureQuery",
    "selections": [
      (v2/*: any*/)
    ]
  },
  "params": {
    "cacheID": "e38f8107223c1c80265b3bf0585d2333",
    "id": null,
    "metadata": {},
    "name": "OrgAdminStructureQuery",
    "operationKind": "query",
    "text": "query OrgAdminStructureQuery {\n  organisation {\n    id\n    name\n    workspaces {\n      id\n      name\n      parentId\n      timezone\n      ownerStores {\n        id\n        name\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "911b5a73b08a4a2c60f08720efa69a6e";

export default node;
